import { Rate } from "rsuite";
import ThumbnailWidget from "../../Widgets/ThumbnailWidget/ThumbnailWidget";

interface Props {
  review: any;
}

const ReviewCard = ({ review }: Props) => {
  return (
    <div className="tw:flex tw:flex-col">
      <div className="tw:flex tw:items-center">
        <ThumbnailWidget
          record={review.Contact}
          mode="Avatar"
          imageKey={undefined}
        />
        <span style={{ fontSize: 16, fontWeight: 600 }}>{review?.User}</span>
      </div>
      <Rate
        defaultValue={review.Rating}
        color="orange"
        allowHalf
        style={{
          fontSize: 14,
          padding: 0,
          marginTop: 10,
          marginBottom: 10,
          height: 10,
          width: 10,
          gap: 10,
        }}
      />
      <p style={{ fontSize: 16 }}>{review.Review}</p>
    </div>
  );
};

export default ReviewCard;
